import { Helmet, HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

import { useNewYearSeason } from 'hooks/useNewYearSeason';
import { useAppNewVersion, useTimeLocaleResolver } from 'hooks/utility';
import { isTestnet } from 'web3';

import { AppProviders } from './providers/AppProviders';
import { Routing } from './router/Routing';

const FAVICONS = {
  regular: '/images/favicon/pg-logo.ico',
  regularDev: '/images/favicon/pg-logo-dev.ico',
  newYear: '/images/favicon/pg-logo-ny.ico',
  newYearDev: '/images/favicon/pg-logo-ny-dev.ico',
} as const;

const browserRouterFuture = {
  v7_startTransition: true,
  v7_relativeSplatPath: true,
} as const;

const AppHelmet = () => {
  const useNewYear = useNewYearSeason();
  const faviconHref = isTestnet
    ? useNewYear
      ? FAVICONS.newYearDev
      : FAVICONS.regularDev
    : useNewYear
      ? FAVICONS.newYear
      : FAVICONS.regular;

  return (
    <Helmet>
      <title>Market Maker</title>
      <link rel="icon" href={faviconHref} type="image/x-icon" />
    </Helmet>
  );
};

export function App() {
  useTimeLocaleResolver();
  useAppNewVersion();

  return (
    <HelmetProvider>
      <BrowserRouter future={browserRouterFuture}>
        <AppProviders>
          <AppHelmet />
          <Routing />
        </AppProviders>
      </BrowserRouter>
    </HelmetProvider>
  );
}
